import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactSVG from 'react-svg';

const ER_APP_BAR_LOGO = process.env.REACT_APP_BAR_LOGO_SVG;

const FuelerIcon = ({
    icon,
    onClick,
    size,
    width = size,
    height = size,
    fill,
    stroke,
    className,
    text = ''
}) => {

    const IconContainer = styled.div`
        height: ${height};
        width: ${width};
        cursor: ${!!onClick ? 'pointer' : 'auto'};
        display: flex;
        flex-direction: column;
        justify-content: center;
    `;

    const IconSVG = styled.svg`
        fill: ${fill};
        stroke: ${stroke};
        height: ${size};
        width: ${size};
    `;

    const createSVG = (content, width, height, svgWidth = size, svgHeight = size) => {
        const svgStyle = {
            height: svgHeight,
            width: svgWidth
        }

        return (
            <IconSVG style={svgStyle} viewBox={['0','0', width, height].join(' ')} preserveAspectRatio="xMidYMid meet">
                {content}
            </IconSVG>
        )
    }

    const getIcon = (icon) => {
        switch (icon) {
            case 'settings':
                let settings = (<path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65c-.03-.24-.24-.42-.49-.42h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-7.43 2.52c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"></path>)
                return createSVG(settings, 24, 24);
            case 'fuel-pump':
                let fuelPump = (<path d="M19.77 7.23l.01-.01-3.72-3.72-1.06 1.06 2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1v-4.5c0-1.1-.9-2-2-2h-1v-7c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5v-9.5c0-.69-.28-1.32-.73-1.77zm-7.77 2.77h-6v-5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path>)
                return createSVG(fuelPump, 24, 24);
            case 'online':
                let onlineStatus = (<circle cx="12" cy="12" r="10"></circle>);
                return createSVG(onlineStatus, 24, 24);
            case 'offline':
                let offlineStatus = (
                    <g>
                        <path d="M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z"></path>
                        <text fontSize="16" fill="white" fontFamily="Verdana" textAnchor="start" x="22"y="12">{text}</text>
                    </g>
                );
                return createSVG(offlineStatus, 36, 24, '26px', '16px');
            case 'fueler':
                return (<ReactSVG src={ER_APP_BAR_LOGO} />);
            case 'checklist':
                let checklist = (
                        <path
                            d="M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
                            style={{fill: 'rgb(250, 69, 60)'}}/>
                );

                return createSVG(checklist, 24, 24);
            case 'check':
                let check = (
                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"></path>
                );
                return createSVG(check, 24, 24);
            case 'upload':
                let upload = (
                    <path d="M46,19c0-0.3,0-0.7,0-1v-0.1C46,8,38,0,28.1,0h-0.1c-8.5,0-15.7,5.9-17.5,14C4.6,14.5,0,19.4,0,25.3v0.4    C0,31.9,5.1,37,11.3,37H19v-2h-7.7C6.2,35,2,30.8,2,25.7v-0.4c0-5.1,4.2-9.3,9.3-9.3l0.8,0l0.1-0.8C13.6,7.5,20.2,2,27.9,2h0.1    C36.9,2,44,9.1,44,17.9v0.1c0,0.6,0,1.2-0.1,1.8L43.8,21h1.5c3.7,0,6.8,3,6.8,6.8v0.5c0,3.7-3,6.8-6.8,6.8H37v2h8.2    c4.8,0,8.8-3.9,8.8-8.8v-0.5C54,23.2,50.5,19.4,46,19z M28.9,24.2c-0.1-0.1-0.3-0.2-0.4-0.2c-0.4-0.2-0.9-0.2-1.2,0.1l-6,5.9    c-0.4,0.4-0.4,1,0,1.4c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3l4.3-4.2V46c0,0.6,0.4,1,1,1c0.6,0,1-0.4,1-1V27.2l4.3,4.4    c0.2,0.2,0.5,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L28.9,24.2z"
                        style={{fill: (fill || 'rgb(250, 69, 60)')}}
                        />
                );
                return createSVG(upload, 50, 50, 30, 50);
            case 'logout':
                let logout = (
                    <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                        style={{ fill: fill || "rgb(255, 255, 255)"}}
                        />
                );

                return createSVG(logout, 24, 24);
            default:
                return (<path></path>)
        }
    };

    return (
        <IconContainer className={className} onClick={onClick}>
            {getIcon(icon)}
        </IconContainer>
    );
};

FuelerIcon.propTypes = {
    icon: PropTypes.string.isRequired,
    size: PropTypes.string
};

FuelerIcon.defaultProps = {
    icon: 'fueler',
    size: '24px'
};

export default FuelerIcon;



// WEBPACK FOOTER //
// ./src/components/FuelerIcon.js